import React from 'react';

import FaultByPriorityFilter from './FaultByPriorityFilter';
import clsx from 'clsx';

import * as classes from './TileContainer.module.css';

const TileContainer = ({
    title,
    faultFilters,
    setFaultFilters,
    setSelectedTitle,
    setTileModalOpen,
    selectedTitle,
    children,
    ...props
}) => {

    const handleExpand = () => {
        setSelectedTitle(title);
        setTileModalOpen(true);
    };

    return (
        <div className={classes.TileContainer}>
            <div className={classes.TileHeader}>
                <span className={classes.Title}>
                    {title}
                </span>
                {
                    title === 'Faults By Priority' ?
                        <span className={classes.FaultFilter}>
                            <FaultByPriorityFilter
                                faultFilters={faultFilters}
                                setFaultFilters={setFaultFilters}
                            />
                        </span>
                        :
                        <span />
                }
                {
                    selectedTitle === title ?
                        <span
                            onClick={() => handleExpand()}
                            role="none"
                            className={clsx('material-icons-outlined', classes.Icon)}
                        >
                            close_fullscreen
                        </span>
                        :
                        <span
                            onClick={() => handleExpand()}
                            role="none"
                            className={clsx('material-icons-outlined', classes.Icon)}
                        >
                            open_in_full
                        </span>
                }
            </div>
            <div className={classes.TileBody}>
                {children}
            </div>
        </div>
    );
};

export default TileContainer;
